module.exports = __webpack_public_path__ + "img/man-front.28099920.png";